import { Module } from '@nestjs/common';
import { IndentController } from './indent.controller';
import { IndentService } from './indent.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Indent } from './indent.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { EmployeeService, ProductService, SuppliersService, VehicleService} from '@gtpl/shared-services/masters';
import { VehicleAssignmentService } from '@gtpl/shared-services/transportation';
import { RMGrnService } from '@gtpl/shared-services/raw-material-procurement';
import { HaverstReport } from './harvest-report.entity';
import { IndentItems } from './indent-items.entity';
import { RmReWeighingController } from './rm-re-weighing/rm-re-weighing.controller';
import { RmReWeighingService } from './rm-re-weighing/rm-re-weighing.service';
import { RMReWeighingRepository } from './rm-re-weighing/rm-re-weighing.repository';
import { ReWeighingAdapter } from './rm-re-weighing/dto/re-weighing.adapter';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
@Module({
  imports: [
    TypeOrmModule.forFeature([Indent,HaverstReport, IndentItems, RMReWeighingRepository]),
  ],
  controllers: [IndentController, RmReWeighingController],
  providers: [IndentService,ApplicationExceptionHandler,SuppliersService,RMGrnService, VehicleAssignmentService,EmployeeService,VehicleService,ProductService, RmReWeighingService, ReWeighingAdapter,WhatsAppNotificationService,LogsService,WhatsappBroadCastService]
})
export class IndentModule {}
